module.exports = __webpack_public_path__ + "img/logo_landforma.410fd8d6.png";